define('models/composer/forms/qualityScore/QuestionScore',[
    'lib/knockout',
    'lib/lodash4',
    'util/ObservableModel'
], function (ko, _, ObservableModel) {
    'use strict';

    //
    // Quality Score Result - Question Score Model
    //
    var QuestionScoreModel = ObservableModel.extend({
        defaults: {
            type: 'questionScore',
            id: '',
            score: 0
        }
    }, function questionScoreModel_init() {
        var self = this;

        self.modelId = _.uniqueId('questionScore'); //Create an id like "fooXX"
    });

    return QuestionScoreModel;
});
